import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import { stringifyQuery, parseQuery } from "./utils/query";

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  // stringifyQuery: stringifyQuery,
  // parseQuery: parseQuery,
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/newsDetails',
      name: 'newsDetails',
      component: () => import('@/views/newsDetails.vue')
    },
    {
      path: '/checkDate',
      name: 'checkDate',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/checkDate.vue')
    },
    {
      path: '/LocalEmpEntry',
      name: 'LocalEmpEntry',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/LocalEmpEntry.vue')
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    // 扫码入职培训确认登录
    {
      path: '/trainSignConfirm',
      name: 'trainSignConfirm',
      component: () => import('./views/trainSignConfirm.vue')
    },
    // 待面试人员列表页面
    {
      path: '/seForm',
      name: 'seForm',
      component: () => import('@/views/scanEntry/seForm.vue')
    },
    {
      path: '/scanEntry',
      name: 'scanEntry',
      component: () => import('@/views/scanEntry/index.vue')
    },
    {
      path: '/seStaList',
      name: 'seStaList',
      component: () => import('@views/scanEntry/seStaList.vue')
    },
    {
      path: '/questionnaire',
      name: 'questionnaire',
      component: () => import('@views/scanEntry/questionnaire.vue')
    },
    {
      path: '/bindWXOpenid',
      name: 'bindWXOpenid',
      component: () => import('@views/bindWXOpenid/index.vue')
    },
    {
      path: '/examinInfo',
      name: 'examinInfo',
      component: () => import('@views/examinInfo/index.vue')
    },
    {
      path: '/examination',
      name: 'examination',
      component: () => import('@views/examination/index.vue')
    },
    {
      path: '/submitPage',
      name: 'submitPage',
      component: () => import('@views/submitPage/index.vue')
    },
    {
      path: '/commonPage',
      name: 'commonPage',
      component: () => import('@views/homePages/commonPage.vue')
    },
    {
      path: '/lecture',
      name: 'lecture',
      component: () => import('@views/homePages/lecture.vue')
    },
    {
      path: '/lectureDetail',
      name: 'lectureDetail',
      component: () => import('@views/homePages/lectureDetail.vue')
    }
  ]
})
